var map = {
	"./chat-icon-bottom-nav-mobile-active.webp": 2713,
	"./chat-icon-bottom-nav-mobile.webp": 2714,
	"./home-icon-bottom-nav-mobile-active.webp": 2715,
	"./home-icon-bottom-nav-mobile-active_b.webp": 2716,
	"./home-icon-bottom-nav-mobile.webp": 2717,
	"./home-icon-bottom-nav-mobile_b.webp": 2718,
	"./me-icon-bottom-nav-mobile-active.webp": 2719,
	"./me-icon-bottom-nav-mobile.webp": 2720,
	"./promo-icon-bottom-nav-mobile-active.webp": 2721,
	"./promo-icon-bottom-nav-mobile.webp": 2722,
	"./sponsor-icon-bottom-nav-mobile-active.webp": 2723,
	"./sponsor-icon-bottom-nav-mobile.webp": 2724,
	"./stream-icon-bottom-nav-mobile-active.webp": 2725,
	"./stream-icon-bottom-nav-mobile.webp": 2726
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2712;